import {connect} from "react-redux";
import {DataInteractions, DispatchProps, InnerProps, StateProps} from "../components/DataInteractions";
import {RootState, ThunkDispatch} from "../types";
import {routerTools, Routes} from "../utils/router";
import {doDownloadHtmlDataXML, doGetDataJson, doGetDataSignatures} from "../actions/thunks/signatures";
import {gotDataJson, gotDataSignatures} from "../actions/signatures";
import {userIsAllowed} from "../utils/commons";
import {doGetUserCredits} from "../actions/thunks/users";

function mapStateToProps({user, data}: RootState): StateProps {
    return {
        apiKeys: user.credentials,
        signatures: data.signatures,
        total: data.total,
        stats: user.credits?.data_api,
        json: data.json,
        isAllowed: userIsAllowed(user.credits, "data_api"),
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch): DispatchProps {
    return {
        onGoToDocumentation: () => window.open(Routes.DOCS, "_blank"),
        onGoToApiKeys: () => routerTools.push(Routes.API_KEYS),
        onGetDataSignatures: (q) => dispatch(doGetDataSignatures(q)),
        onResetDataSignatures: () => dispatch(gotDataSignatures({items: undefined as any, total: 0})),
        onDownloadDataXML: (sig) => dispatch(doDownloadHtmlDataXML(sig)),
        onGetDataJson: (sig) => dispatch(doGetDataJson(sig)),
        onCleanJson: () => dispatch(gotDataJson(undefined)),
        onGetUserCredits: () => dispatch(doGetUserCredits()),
    };
}

export default connect<StateProps, DispatchProps, InnerProps, RootState>(mapStateToProps, mapDispatchToProps)(DataInteractions);
